var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"party-page"},[_c('Party',{attrs:{"id":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }